import { markRaw } from "vue";
import StDelete from "@/components/common/Delete.vue";
import { useUser } from "@/composables/useUser";
import { useTable } from "./useTable";

export const useAdminAccountsTable = () => {
  const user = useUser();
  const table = useTable((account) => ({
    accountId: account.accountId,
    organizationNumber: account.organizationNumber,
    organizationName: account.companyName,
    accountName: account.displayName,
    delete: {
      component: markRaw(StDelete),
      componentProps: { disabled: !user.state.isAdmin },
      componentEmits: ["delete"],
      clickable: true,
    },
  }));

  const getTableHeaders = () => [
    { name: "Kundnummer", isSortable: false },
    { name: "Org.nummer", isSortable: false },
    { name: "Org.namn", isSortable: false },
    { name: "Kontonamn", isSortable: false },
    { name: "Ta bort", isSortable: false },
  ];

  return {
    ...table,
    getTableHeaders,
  };
};
